import { useConfig } from '../../../../../React/Common/Hooks/useConfig'

export type ExternalComponentConfig = {
    jsLink: Nullable<string>
    cssLink: Nullable<string>
    componentID: string
    mountOptions: Nullable<Record<string, unknown>>
}

const EXTERNAL_COMPONENT_CONFIG_FILENAME: string = 'external-component-config'
const JS_LINK_KEY: string = 'jsLink'
const CSS_LINK_KEY: string = 'cssLink'
const COMPONENT_ID_KEY: string = 'componentID'
const MOUNT_OPTIONS_KEY: string = 'mountOptions'

/**
 * Custom hook to retrieve the configuration for an external component based on a provided component key.
 *
 * @param componentKey - A unique key used to identify the external component and retrieve its configuration.
 *
 * @returns An object containing the JS link, CSS link, component ID, and mount options for the external component.
 */
export const useExternalComponentConfig = (componentKey: string): ExternalComponentConfig => {
    const jsLink: Nullable<string> = useConfig(EXTERNAL_COMPONENT_CONFIG_FILENAME, `${componentKey}.${JS_LINK_KEY}`)
    const cssLink: Nullable<string> = useConfig(EXTERNAL_COMPONENT_CONFIG_FILENAME, `${componentKey}.${CSS_LINK_KEY}`)
    const componentID: string = useConfig(
        EXTERNAL_COMPONENT_CONFIG_FILENAME,
        `${componentKey}.${COMPONENT_ID_KEY}`,
        componentKey
    )
    const mountOptions: Nullable<Record<string, unknown>> = useConfig(
        EXTERNAL_COMPONENT_CONFIG_FILENAME,
        `${componentKey}.${MOUNT_OPTIONS_KEY}`,
        {}
    )

    return { jsLink, cssLink, componentID, mountOptions }
}
